import { create } from "zustand";
import { jsonGet } from "../api";

const JOB_TYPE_LABELS = {
  ContentGenerationJob: "content generation",
  ImageGenerationJob: "image generation",
  ContentTranslationJob: "translation",
};

const ACTIVE_INTERVAL = 10_000;
const IDLE_INTERVAL = 60_000;

export const useJobsActivityStore = create((set, get) => ({
  totalActive: 0,
  byType: {},
  _intervalId: null,
  _prevActive: 0,

  fetchSummary: async () => {
    try {
      const data = await jsonGet("jobs/active-summary");
      const prev = get().totalActive;
      set({ totalActive: data.totalActive, byType: data.byType, _prevActive: prev });

      // Adjust polling frequency based on activity
      const intervalId = get()._intervalId;
      if (intervalId) {
        const newInterval = data.totalActive > 0 ? ACTIVE_INTERVAL : IDLE_INTERVAL;
        const currentInterval = prev > 0 ? ACTIVE_INTERVAL : IDLE_INTERVAL;
        if (newInterval !== currentInterval) {
          clearInterval(intervalId);
          const id = setInterval(get().fetchSummary, newInterval);
          set({ _intervalId: id });
        }
      }
    } catch {
      // Silently ignore — don't break the app if endpoint isn't available
    }
  },

  startPolling: () => {
    if (get()._intervalId) return;
    get().fetchSummary();
    const id = setInterval(get().fetchSummary, IDLE_INTERVAL);
    set({ _intervalId: id });
  },

  stopPolling: () => {
    const id = get()._intervalId;
    if (id) {
      clearInterval(id);
      set({ _intervalId: null });
    }
  },

  getTooltipText: () => {
    const { byType } = get();
    const parts = Object.entries(byType)
      .filter(([, count]) => count > 0)
      .map(([type, count]) => `${count} ${JOB_TYPE_LABELS[type] || type}`);
    return parts.length > 0 ? parts.join(", ") : "No active jobs";
  },
}));
